import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Globe2, ShieldCheck, Coins } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import { IconFeature } from '../SectionHeading';

const IMAGES = [
  { id: 'shipping', src: 'https://images.unsplash.com/photo-1583857671904-a716bf4ee5d8?crop=entropy&cs=srgb&fm=jpg&q=85', ratio: 'aspect-square' },
  { id: 'momo', src: 'https://images.pexels.com/photos/36096255/pexels-photo-36096255.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940', ratio: 'aspect-[4/5]' },
  { id: 'delivery', src: 'https://images.unsplash.com/photo-1566576721346-d4a3b4eaeb55?crop=entropy&cs=srgb&fm=jpg&q=85', ratio: 'aspect-[4/5]' },
  { id: 'textile', src: 'https://images.unsplash.com/photo-1768212566108-4ce4f329e4d2?crop=entropy&cs=srgb&fm=jpg&q=85', ratio: 'aspect-square' },
];

const Column = ({ items, offset }) => (
  <div className={`space-y-4 ${offset ? 'mt-10' : ''}`}>
    {items.map((img) => (
      <div key={img.id} className={`${img.ratio} rounded-2xl overflow-hidden shadow-2xl`}><img src={img.src} alt={img.id} className="w-full h-full object-cover" /></div>
    ))}
  </div>
);

export const DiasporaBanner = () => {
  const { t } = useApp();
  const features = [
    { id: 'f1', icon: Coins, title: t('diaspora.feat1.title'), desc: t('diaspora.feat1.desc') },
    { id: 'f2', icon: Globe2, title: t('diaspora.feat2.title'), desc: t('diaspora.feat2.desc') },
    { id: 'f3', icon: ShieldCheck, title: t('diaspora.feat3.title'), desc: t('diaspora.feat3.desc') },
  ];
  return (
    <section className="relative overflow-hidden bg-[#0F8B5C]" data-testid="landing-diaspora-section">
      <div className="absolute inset-0 opacity-20" style={{ backgroundImage: 'radial-gradient(circle at 20% 30%, #F2B441 0%, transparent 40%), radial-gradient(circle at 80% 70%, #E8814A 0%, transparent 40%)' }} />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-white">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/15 backdrop-blur text-white text-xs font-semibold uppercase tracking-wider mb-6"><Globe2 className="w-3.5 h-3.5" /> {t('diaspora.eyebrow')}</span>
            <h2 className="text-4xl md:text-5xl font-black tracking-tight leading-tight">{t('diaspora.title')}</h2>
            <p className="mt-4 text-lg text-white/90 max-w-lg">{t('diaspora.subtitle')}</p>
            <div className="mt-8 space-y-5">{features.map((f) => <IconFeature key={f.id} dark {...f} />)}</div>
            <Link to="/diaspora" data-testid="landing-diaspora-cta" className="inline-flex items-center gap-2 mt-8 px-6 py-3 bg-white text-[#0F8B5C] font-semibold rounded-xl hover:bg-[#F2B441] hover:text-[#1A1A1A] transition-colors">
              {t('land.discoverDiaspora')} <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <Column items={IMAGES.slice(0, 2)} />
            <Column items={IMAGES.slice(2)} offset />
          </div>
        </div>
      </div>
    </section>
  );
};
